import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class LoadingOverlay extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            ellipsis: '.m-loadingOverlay__ellipsis',
        };
    }

    show() {
        this.updateProps({ visible: true }, true);
        if (this.dom.ellipsis) {
            const rectangle = this.dom.el.getBoundingClientRect();
            const top = (Math.min(rectangle.bottom, window.innerHeight) - rectangle.top) / 2;
            this.dom.ellipsis.style.top = `${top}px`;
        }
    }

    hide() {
        this.updateProps({ visible: false }, true);
    }
}
